import { Box, Typography } from "@mui/material";
import React from "react";
import KarenCoin from "../../../../../../../../media/images/icons/karenCoin.svg";
import sendpoint from "../../../../../../../../media/images/icons/sendpoint.svg";
import receivedpoint from "../../../../../../../../media/images/icons/receivedpoint.svg";

interface Props {
  status: "send" | "received";
}

export default function HistoryCard({ status }: Props) {
  return (
    <Box
      sx={{
        backgroundColor:
          status === "send" ? "secondary.main" : "secondary.light",
        border: "1px solid gray",
        display: "flex",
        padding: "8px",
        borderRadius: "16px",
        gap: "16px",
      }}
    >
      <Box
        sx={{
          width: "50%",
          //   border: "1px solid gray",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            backgroundColor:
              status === "send" ? "secondary.light" : "success.light",
            height: "fit-content",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "4px",
            borderRadius: "8px",
          }}
        >
          <img src={status === "send" ? sendpoint : receivedpoint} alt="" />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              paddingX: "8px",
              paddingY: "8px",
              borderRadius: "8px",
              width: "fit-content",
              backgroundColor: "#424242",
            }}
          >
            <img width={18} src={KarenCoin} alt="" />
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "600",
              }}
              color={"#FFD54F"}
            >
              47
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "600",
              }}
              color={"#FFD54F"}
            >
              کارن پوینت
            </Typography>
          </Box>
          <Typography>1402/12/04 - 10:35</Typography>
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: status === "send" ? "" : "info.light",
          borderRadius: "16px",
          width: "50%",
          //   border: "1px solid gray",
          padding: "8px",
        }}
      >
        <Typography
          sx={{
            color: status === "send" ? "#fff" : "",
            fontWeight: "600",
          }}
        >
          دریافت بابت ماموریت:
        </Typography>
        <Typography
          sx={{
            color: status === "send" ? "#fff" : "",
          }}
        >
          حمل دو محموله بار از تهران به خراسان جنوبی
        </Typography>
      </Box>
    </Box>
  );
}
